<template>
  <div class="navBox">
    <div class="top-nav-box">
      <div class="top-nav-con">
        <div class="left-con">
          <div class="logo-con">戴尔官方企采中心</div>
          <div class="gzh-box pointer">
            <span>关注公众号 <i class="iconfont icon-xiangxia2"></i></span>
            <img src="https://www.dellemc-solution.com/static/pc/img/gzh_qrcode.png" alt="">
          </div>
          <div class="xcx-box pointer">
            <span>前往小程序 <i class="iconfont icon-xiangxia2"></i></span>
            <img src="https://www.dellemc-solution.com/static/pc/img/account/register/xcx_qrcode.png" alt="">
          </div>
        </div>
        <div class="right-con">
          <div class="kefu-qq pointer" @click="openQidiankefu">
            <img src="@/assets/nav/qq.png" alt="qq">
            在线客服
          </div>
          <div class="phone-con">
            <img src="@/assets/nav/phone.png" alt="qq">
            会员专享热线400-884-6610
          </div>
          <!-- 会员中心 -->
          <div class="meCore" :class="{'meCore-is-login': userInfo}" @mouseover="getUserCardInfo">
            <div class="no-login-text" v-if="!userInfo">
              <span class="pointer" @click="gotoLogin">请登录</span>
              |
              <span class="pointer" @click="gotoRegister">注册有礼</span>
            </div>
            <span class="login-user-name" :class="{'navErbtnShowUser':userInfo}" v-if="userInfo"
                  @mouseenter="hoverNavUser"
            >{{ truename }}</span>

            <!--用户信息浮窗 BEIGN-->
            <div class="login-info" id="nav-user-info-card">
              <div class="user-info">
                <div class="user-info-box">
                  <a data-eshop-href="/account/account" target="_blank" rel="noopener noreferrer">
                    <div class="user-avatar">
                      <img :src="userCardInfo.avatar" id="nav-user-card-avatar" alt="">
                    </div>
                    <div class="user-name-comp">
                      <div class="user-name" id="nav-user-card-name">{{ userCardInfo.name }}</div>
                      <div class="user-comp" id="nav-user-card-enterprise_name">{{ userCardInfo.comp }}</div>
                    </div>
                  </a>
                </div>
                <div class="action-btn">
                  <span><a data-solution-href="/user/edit.html#editinfo" target="_blank" rel="noopener noreferrer">修改信息</a></span>
                  <span @click="loginOut">退出登录</span>
                </div>
                <div class="user-data">
                  <div class="user-data-item">
                    <a data-eshop-href="/account/order?category=0" target="_blank" rel="noopener noreferrer">
                      <div class="user-data-num" id="nav-user-card-order">
                        {{ userCardInfo.order }}
                      </div>
                      <div class="user-data-name">
                        我的订单
                      </div>
                    </a>
                  </div>
                  <div class="user-data-item">
                    <a data-eshop-href="/account/coupon" target="_blank" rel="noopener noreferrer">
                      <div class="user-data-num" id="nav-user-card-coupon">
                        {{ userCardInfo.coupon }}
                      </div>
                      <div class="user-data-name">
                        优惠券
                      </div>
                    </a>
                  </div>
                  <div class="user-data-item">
                    <a data-solution-href="/user/schedule.html" target="_blank" rel="noopener noreferrer">
                      <div class="user-data-num" id="nav-user-card-schedule">
                        {{ userCardInfo.schedule }}
                      </div>
                      <div class="user-data-name">
                        日程
                      </div>
                    </a>
                  </div>
                  <div class="user-data-item">
                    <a data-solution-href="/user/favorite.html" target="_blank" rel="noopener noreferrer">
                      <div class="user-data-num" id="nav-user-card-collect">
                        {{ userCardInfo.collect }}
                      </div>
                      <div class="user-data-name">
                        收藏
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div class="vip-serve">
                <div class="vip-item">
                  <a data-solution-href="/campaigns/try/pc/#/home?mediasources=solution-top-login_floaticon_to0try"
                     target="_blank" rel="noopener noreferrer" onclick="gioTrackAction12.gio_base('eshop_toplogin_floaticonclick_0try')">
                    <div class="vip-icon">
                      <img src="@/assets/nav/icon-1.png" alt="">
                    </div>
                    <div class="vip-name">
                      0元尝鲜
                    </div>
                    <div class="vip-desc">
                      新品优先试用
                    </div>
                  </a>
                </div>
                <div class="vip-item">
                  <a data-solution-href="/services/guarantee?mediasources=solution-top-login_floaticon_toguarantee"
                     target="_blank" rel="noopener noreferrer" onclick="gioTrackAction12.gio_base('eshop_toplogin_floaticonclick_yanbao')">
                    <div class="vip-icon">
                      <img src="@/assets/nav/icon-2.png" alt="">
                    </div>
                    <div class="vip-name">
                      一键延保
                    </div>
                    <div class="vip-desc">
                      售后无忧
                    </div>
                  </a>
                </div>
                <div class="vip-item">
                  <a data-solution-href="/campaign/review-collection?mediasources=solution-top-login_floaticon_toreview-collection"
                     target="_blank" rel="noopener noreferrer" onclick="gioTrackAction12.gio_base('eshop_toplogin_floaticonclick_zhengji')">
                    <div class="vip-icon">
                      <img src="@/assets/nav/icon-3.png" alt="">
                    </div>
                    <div class="vip-name">
                      征集有礼
                    </div>
                    <div class="vip-desc">
                      超值礼遇
                    </div>
                  </a>
                </div>
                <div class="vip-item">
                  <a @click="openQidiankefu"
                     onclick="gioTrackAction12.gio_base('eshop_toplogin_floaticonclick_chat')">
                    <div class="vip-icon">
                      <img src="@/assets/nav/icon-4.png" alt="">
                    </div>
                    <div class="vip-name">
                      专属服务
                    </div>
                    <div class="vip-desc">
                      售前售后全程服务
                    </div>
                  </a>
                </div>
              </div>
              <div class="loading-box" v-show="!isGetUserCardInfoIng" id="nav-user-info-card-loading">
                <img src="//www.dellemc-solution.com/static/pc/img/loading-animation-square.gif" alt="">
              </div>
            </div>
            <!--用户信息浮窗 END-->
          </div>
        </div>
      </div>
    </div>
    <div class="navCont clearfix">
      <!--logo图-->
      <h1 class="leftLogo fl"><a href='https://www.dellemc-solution.com' target="_blank" rel="noopener noreferrer">戴尔</a></h1>
      <div class="rightCont fl">
        <!-- 导航 -->
        <ul class="navItemList fl">
          <li class="navErBtn">
            <a href='https://www.dellemc-solution.com' target="_blank" rel="noopener noreferrer" onclick="gioTrackAction12.navGioEvent('商城','商城', '','', false)">商城</a>
            <i class="more-icon iconfont icon-playfill"></i>
            <div class="boxSize xiaList cus-width">
              <div class="navErList">
                <div class="navErItem">
                  <a class="pointer" data-solution-href="/product/notebook.html" target="_blank" rel="noopener noreferrer"
                     onclick="gioTrackAction12.navGioEvent('商用笔记本','商城','商用笔记本','', false)">商用笔记本</a>
                </div>
              </div>
              <div class="navErList">
                <div class="navErItem">
                  <a class="pointer" data-solution-href="/product/workstation.html" target="_blank" rel="noopener noreferrer"
                     onclick="gioTrackAction12.navGioEvent('专业工作站','商城','专业工作站','', false)">专业工作站</a>
                </div>
              </div>
              <div class="navErList">
                <div class="navErItem">
                  <a class="pointer" data-solution-href="/product/computer.html" target="_blank" rel="noopener noreferrer"
                     onclick="gioTrackAction12.navGioEvent('商用台式机','商城','商用台式机','', false)">商用台式机</a>
                </div>
              </div>
              <div class="navErList">
                <div class="navErItem">
                  <a class="pointer" data-solution-href="/product/monitor.html" target="_blank" rel="noopener noreferrer"
                     onclick="gioTrackAction12.navGioEvent('显示器及外设','商城','显示器及外设','', false)">显示器及外设</a>
                </div>
              </div>
              <div class="navErList">
                <div class="navErItem">
                  <a class="pointer" data-solution-href="/product/server.html" target="_blank" rel="noopener noreferrer"
                     onclick="gioTrackAction12.navGioEvent('服务器特惠','商城','服务器特惠','', false)">服务器特惠</a>
                </div>
              </div>
              <div class="navErList">
                <div class="navErItem">
                  <a class="pointer" data-solution-href="/product/networking.html" target="_blank" rel="noopener noreferrer"
                     onclick="gioTrackAction12.navGioEvent('易部署网络','商城','易部署网络','', false)">易部署网络</a>
                </div>
              </div>
              <div class="navErList">
                <div class="navErItem">
                  <a class="pointer" data-solution-href="/product/storage.html" target="_blank" rel="noopener noreferrer"
                     onclick="gioTrackAction12.navGioEvent('高容量存储','商城','高容量存储','', false)">高容量存储</a>
                </div>
              </div>
              <div class="navErList">
                <div class="navErItem">
                  <a class="pointer" data-solution-href="/product/infrastructure-hyper-converged-Infrastructure.html" target="_blank" rel="noopener noreferrer"
                     onclick="gioTrackAction12.navGioEvent('超融合架构','商城','超融合架构','', false)">超融合架构</a>
                </div>
              </div>
              <div class="navErList">
                <div class="navErItem">
                  <a class="pointer" data-solution-href="/product/protection.html" target="_blank" rel="noopener noreferrer"
                     onclick="gioTrackAction12.navGioEvent('数据保护','商城','数据保护','', false)">数据保护</a>
                </div>
              </div>
              <div class="navErList">
                <div class="navErItem">
                  <a class="pointer" data-solution-href="/services" target="_blank" rel="noopener noreferrer"
                     onclick="gioTrackAction12.navGioEvent('服务','商城','服务','', false)">服务</a>
                </div>
              </div>
            </div>
          </li>
          <li class="navErBtn">
            <a href="javascript: void(0)">会员特惠福利</a>
            <i class="more-icon iconfont icon-playfill"></i>
            <div class="boxSize xiaList xiaListWidth">
              <div class="navErItem nav-align-left">
                <span>
                   <a class="pointer" data-solution-href="/membership.html" target="_blank"
                      rel="noopener noreferrer"
                      onclick="gioTrackAction12.navGioEvent('会员权益','会员特惠福利', '会员权益', '', false);">
                      会员权益
                   </a>
                </span>
              </div>
              <div class="navErItem nav-align-left">
                <span>
                   <a class="pointer" data-solution-href="/campaign/promotion" target="_blank"
                      rel="noopener noreferrer"
                      onclick="gioTrackAction12.navGioEvent('会员活动','会员特惠福利', '会员活动', '', false);">
                      会员活动
                   </a>
                </span>
              </div>
              <div class="navErItem nav-align-left">
                <span>
                   <a class="pointer" data-solution-href="/campaigns/try/pc/#/home" target="_blank"
                      rel="noopener noreferrer"
                      onclick="gioTrackAction12.navGioEvent('0元试用','会员特惠福利', '0元试用', '', false);">
                      0元试用<span class="hot-tag"></span>
                   </a>
                </span>
              </div>
              <div class="navErItem nav-align-left">
                <span>
                   <a class="pointer" data-solution-href="/latest-dell-products" target="_blank"
                      rel="noopener noreferrer"
                      onclick="gioTrackAction12.navGioEvent('2025新品专区','会员特惠福利', '2025新品专区', '', false);">
                      2025新品专区<span class="aipc-tag"></span>
                   </a>
                </span>
              </div>
              <div class="navErItem nav-align-left">
                <span>
                   <a class="pointer" data-solution-href="/campaign/trade-in" target="_blank"
                      rel="noopener noreferrer"
                      onclick="gioTrackAction12.navGioEvent('资产回收','会员特惠福利', '资产回收', '', false);">
                      资产回收
                   </a>
                </span>
              </div>
              <div class="navErItem nav-align-left">
                <span>
                   <a class="pointer" data-solution-href="/campaign/coupon/index" target="_blank"
                      rel="noopener noreferrer"
                      onclick="gioTrackAction12.navGioEvent('专属优惠券','会员特惠福利', '专属优惠券', '', false);">
                      专属优惠券
                   </a>
                </span>
              </div>
            </div>
          </li>
          <li class="navErBtn">
            <a href="javascript: void(0)">线上会议/精品课</a>
            <i class="more-icon iconfont icon-playfill"></i>
            <div class="boxSize xiaList xiaListWidth">
              <div class="navErItem nav-align-left">
                  <span>
                      <a class="pointer"
                         data-solution-href="/meeting/online-meeting.html"
                         target="_blank"
                         onclick="gioTrackAction12.navGioEvent('线上沙龙','市场活动','线上会议','', false)">
                          线上会议
                      </a>
                  </span>
              </div>
              <div class="navErItem nav-align-left">
                <span>
                    <a class="pointer" data-solution-href="/campaign/SDI-PowerFlex"
                       target="_blank"
                       onclick="gioTrackAction12.navGioEvent('存储专家特约课程','市场活动', '热门活动', '存储专家特约课程', false);">
                        存储专家特约课程
                    </a>
                </span>
              </div>
              <div class="navErItem nav-align-left">
                  <span class="title-text-cus">
                      热门活动
                  </span>
              </div>
              <div class="navErItem nav-align-left">
                <span>
                     <a class="pointer" data-solution-href="/latest-dell-products"
                        target="_blank"
                        onclick="gioTrackAction12.navGioEvent('2025新品专区','市场活动', '热门活动', '2025新品专区', false);">
                        2025新品专区<span class="aipc-tag"></span>
                    </a>
                </span>
              </div>
<!--              <div class="navErItem nav-align-left">-->
<!--                <span>-->
<!--                     <a class="pointer" data-solution-href="/campaign/ai-pc-solution"-->
<!--                        target="_blank"-->
<!--                        onclick="gioTrackAction12.navToMb();gioTrackAction12.navGioEvent('AI PC 活动专区','市场活动', '热门活动', 'AI PC 活动专区', false);">-->
<!--                        AI PC 活动专区<span class="hot-tag"></span>-->
<!--                    </a>-->
<!--                </span>-->
<!--              </div>-->
              <div class="navErItem nav-align-left">
                <span>
                     <a class="pointer" data-solution-href="/campaign/new-server"
                        target="_blank"
                        onclick="gioTrackAction12.navGioEvent('新一代服务器专区','市场活动', '热门活动', '新一代服务器专区', false);">
                        新一代服务器专区
                    </a>
                </span>
              </div>
              <div class="navErItem nav-align-left">
                <span>
                     <a class="pointer" data-solution-href="/campaign/2020mb"
                        target="_blank"
                        onclick="gioTrackAction12.navToMb();gioTrackAction12.navGioEvent('成长型企业专区','市场活动', '热门活动', '成长型企业专区', false);">
                        成长型企业专区
                    </a>
                </span>
              </div>
              <div class="navErItem nav-align-left">
                <span>
                     <a class="pointer" data-solution-href="/campaign/small-promotion"
                        target="_blank"
                        onclick="gioTrackAction12.navToMb();gioTrackAction12.navGioEvent('小企业特惠专区','市场活动', '热门活动', '小企业特惠专区', false);">
                        小企业特惠专区
                    </a>
                </span>
              </div>
            </div>
          </li>
          <li class="navErBtn">
            <a href="javascript: void(0)">案例/报告</a>
            <i class="more-icon iconfont icon-playfill"></i>
            <div class="boxSize xiaList">
              <div class="navErList">
                <div class="navErItem">
                  <a class="pointer" data-solution-href="/resource-top/index" target="_blank" rel="noopener noreferrer"
                     onclick="gioTrackAction12.navGioEvent('数字化热门报告','案例/报告','数字化热门报告','', false)">数字化热门报告</a>
                </div>
              </div>
              <div class="navErList">
                <div class="navErItem">
                  <a class="pointer" data-solution-href="/casecatalog/" target="_blank" rel="noopener noreferrer"
                     onclick="gioTrackAction12.navGioEvent('热搜案例','案例/报告','热搜案例','', false)">热搜案例</a>
                </div>
              </div>
              <div class="navErList">
                <div class="navErItem">
                  <a class="pointer" data-solution-href="/solutioncatalog/" target="_blank" rel="noopener noreferrer"
                     onclick="gioTrackAction12.navGioEvent('产品手册','案例/报告','产品手册','', false)">产品手册</a>
                </div>
              </div>
              <div class="navErList">
                <div class="navErItem">
                  <a class="pointer" data-solution-href="/evaluation/" target="_blank" rel="noopener noreferrer"
                     onclick="gioTrackAction12.navGioEvent('产品评测','案例/报告','产品评测','', false)">产品评测</a>
                </div>
              </div>
            </div>
          </li>
          <li class="navErBtn">
            <a href="javascript: void(0)">解决方案精选</a>
            <i class="more-icon iconfont icon-playfill"></i>
            <div class="boxSize xiaList">
              <div class="navErList">
                <div class="navErItem">
                  <a class="pointer" data-solution-href="/fod" target="_blank" rel="noopener noreferrer"
                     onclick="gioTrackAction12.navGioEvent('\'即服务\'IT解决方案','解决方案精选','\'即服务\'IT解决方案','', false)">"即服务"IT解决方案</a>
                </div>
              </div>
              <div class="navErList">
                <div class="navErItem">
                  <a class="pointer" data-solution-href="/campaign/edge-computing/index" target="_blank"
                     rel="noopener noreferrer"
                     onclick="gioTrackAction12.navGioEvent('边缘计算解决方案','解决方案精选','边缘计算解决方案','', false)">边缘计算解决方案</a>
                </div>
              </div>
              <div class="navErList">
                <div class="navErItem">
                  <a class="pointer" data-solution-href="/campaign/hyper-converged-vxrail" target="_blank"
                     rel="noopener noreferrer"
                     onclick="gioTrackAction12.navGioEvent('超融合解决方案','解决方案精选','超融合解决方案','', false)">超融合解决方案</a>
                </div>
              </div>
              <div class="navErList">
                <div class="navErItem">
                  <a class="pointer" data-solution-href="/campaign/apex-cloud" target="_blank" rel="noopener noreferrer"
                     onclick="gioTrackAction12.navGioEvent('APEX 云平台','解决方案精选','APEX 云平台','', false)">APEX
                    云平台</a>
                </div>
              </div>
              <div class="navErList">
                <div class="navErItem nohover nav-align-left">
                  <span>
                      <a href="javascript: void(0)">
                          行业解决方案
                          <i class="iconfont icon-right"></i>
                      </a>
                  </span>
                  <div class="cpsolution">
<!--                    <a class="pointer" data-solution-href="/campaigns/try/pc/#/home" target="_blank"-->
<!--                       rel="noopener noreferrer"-->
<!--                       onclick="gioTrackAction12.navGioEvent('新品0元试用','解决方案精选', '行业解决方案','新品0元试用', false)">新品0元试用</a>-->
                    <a class="pointer" data-solution-href="/campaign/industries" target="_blank"
                       rel="noopener noreferrer"
                       onclick="gioTrackAction12.navGioEvent('行业成功案例','解决方案精选', '行业解决方案','行业成功案例', false)">行业成功案例</a>
                    <a class="pointer" data-solution-href="/industries/education" target="_blank"
                       rel="noopener noreferrer"
                       onclick="gioTrackAction12.navGioEvent('教育行业','解决方案精选', '行业解决方案','教育行业', false)">教育行业</a>
                    <a class="pointer" data-solution-href="/industries/manufacture" target="_blank"
                       rel="noopener noreferrer"
                       onclick="gioTrackAction12.navGioEvent('制造行业','解决方案精选', '行业解决方案','制造行业', false)">制造行业</a>
                    <a class="pointer" data-solution-href="/industries/finance" target="_blank"
                       rel="noopener noreferrer"
                       onclick="gioTrackAction12.navGioEvent('金融行业','解决方案精选', '行业解决方案','金融行业', false)">金融行业</a>
                    <a class="pointer" data-solution-href="/industries/telecom" target="_blank"
                       rel="noopener noreferrer"
                       onclick="gioTrackAction12.navGioEvent('电信行业','解决方案精选', '行业解决方案','电信行业', false)">电信行业</a>
                    <a class="pointer" data-solution-href="/industries/healthcare" target="_blank"
                       rel="noopener noreferrer"
                       onclick="gioTrackAction12.navGioEvent('医疗行业','解决方案精选', '行业解决方案','医疗行业', false)">医疗行业</a>
                    <a class="pointer" data-solution-href="/industries/energy" target="_blank"
                       rel="noopener noreferrer"
                       onclick="gioTrackAction12.navGioEvent('能源行业','解决方案精选', '行业解决方案','能源行业', false)">能源行业</a>
                    <a class="pointer" data-solution-href="/industries/transportation"
                       target="_blank" rel="noopener noreferrer"
                       onclick="gioTrackAction12.navGioEvent('交通行业','解决方案精选', '行业解决方案','交通行业', false)">交通行业</a>
                    <a class="pointer" data-solution-href="/industries/media" target="_blank"
                       rel="noopener noreferrer"
                       onclick="gioTrackAction12.navGioEvent('媒体行业','解决方案精选', '行业解决方案','媒体行业', false)">媒体行业</a>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <!--搜索框-->
        <div class="searchBox pointer" @click="gotoSearch">
          <div class="searchCon">
            <img class="searchImg" src="@/assets/nav/search.png" alt="搜索">
            <div class="form-control">工作站</div>
            <div class="searchBtn">搜索</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navErbtnShowUserOpen: false,
      userInfo: {},
      truename: '',
      tel: '',
      email: '',
      company: '',
      address: '',
      needComplete: false,
      isGetUserCardInfoIng: true, //设置用户面板的信息
      isUserCardGet: false, //是否获取过用户信息
      userCardInfo: {
        avatar: '//www.dellemc-solution.com/static/default/avatar.png',
        name: '匿名',
        comp: '未设置',
        order: 0,
        coupon: 0,
        schedule: 0,
        collect: 0
      }
    }
  },
  created() {
    this.userInfo = this.cookies.get("smarketMember_498")
    if (this.cookies.get("smarketMember_498")) {
      this.getSmarketLoginInfo();
    }
  },
  mounted() {
    const _this = this;
    console.log(_this.solution_host)
    $('.navItemList .navErBtn').hover(function () {
      $(this).find('.xiaList').stop();
      $(this).find('.xiaList').fadeIn(400);
    }, function () {
      $(this).find('.xiaList').stop();
      $(this).find('.xiaList').fadeOut(400);
    });
    //三级导航
    $('.nohover').hover(function () {
      $(this).find('.cpsolution').stop();
      $(this).find('.cpsolution').fadeIn(400);
    }, function () {
      $(this).find('.cpsolution').stop();
      $(this).find('.cpsolution').fadeOut(400);
    });
    $('[data-eshop-href]').each(function () {
      var self = $(this);
      self.attr('href', _this.eshop_host + self.attr('data-eshop-href'));
    });

    $('[data-solution-href]').each(function () {
      var self = $(this);
      self.attr('href', _this.solution_host + self.attr('data-solution-href'));
    })
  },
  methods: {
    hoverNavUser() {
      this.navErbtnShowUserOpen = true
    },
    noHoverNavUser() {
      this.navErbtnShowUserOpen = false
    },
    gotoLogin() {
      window.location.href = this.solution_host + '/account/login?backUrl=' + encodeURIComponent(window.location.href) + this.$store.state.pageRecordUrl
    },
    gotoRegister() {
      window.location.href = this.solution_host + '/account/register?backUrl=' + encodeURIComponent(window.location.href) + this.$store.state.pageRecordUrl

    },
    gotoSearch() {
      window.location.href = this.solution_host + '/list?kw=工作站&ishot=2&searchmodule=搜索&type=all'
    },
    ModifyPassword() {
      window.location.href = this.solution_host + "/user/edit.html#changepassword";
      //判断是否处在个人信息修改页面
      if (window.location.href == this.solution_host + '/user/edit.html') {
        window.location.reload();
      }
    },
    loginOut() {
      this.cookies.set('smarketMember_498', '', {domain: '.dellemc-solution.com', path: '/'})
      this.cookies.set('OCSESSID', '', {domain: '.dellemc-solution.com', path: '/'})
      this.axios.post(this.solution_host + '/api/account/logout', {}).then(res => {
        if (res.status == 200) {
          this.gotoLogin()
        }
      })
    },
    getSmarketLoginInfo: function () {
      let smarketCookie = this.cookies.get('smarketMember_498');
      if (smarketCookie) {
        smarketCookie = JSON.parse(smarketCookie);
        this.axios.post(window.smk_api_host + '/member/LookUp', {
          sess: smarketCookie.session
        }).then(res => {
          if (res.data.body.result == 0 && res.data.body.content.length > 0) {
            res.data.body.content.forEach(obj => {
              if (obj.key == "name") {
                this.truename = obj.value;
              } else if (obj.key == "mobile") {
                this.tel = obj.value;
              } else if (obj.key == "email") {
                this.email = obj.value;
              } else if (obj.key == "enterprise_name") {
                this.company = obj.value;
              } else if (obj.key == "province" && typeof obj.value == "object") {
                this.address = obj.value.join(',');
              }
            })

            if (!this.truename) {
              this.truename = this.tel.substr(-4);
            }
          }
        })
      }

    },
    async getUserCardInfo() {

      if (this.isUserCardGet) {
        return;
      }

      if (!this.isGetUserCardInfoIng) {
        return false
      }
      this.isGetUserCardInfoIng = false;
      var userSess = common.isLogin();
      var info = {
        "session": userSess.session,
        "OCSESSID": userSess.OCSESSID
      }

      // 从接口获取信息
      let res = await this.axios.post(this.solution_host + '/api/account/info', info)
      console.log(res.data);
      if (res.data.errCode !== 0) {
        return;
      }
      this.setInfo(res.data.data)
    },

    setInfo(info) {
      this.userCardInfo.avatar = info.user_info.avatar || '//www.dellemc-solution.com/static/default/avatar.png'
      this.userCardInfo.name = info.user_info.realname || '匿名'
      this.userCardInfo.comp = info.user_info.enterprise_name || '未设置'
      this.userCardInfo.order = info.record.order || 0
      this.userCardInfo.coupon = info.record.coupon || 0
      this.userCardInfo.schedule = info.record.schedule || 0
      this.userCardInfo.collect = info.record.collect || 0
      this.isGetUserCardInfoIng = true;
      this.isUserCardGet = true;
    }

  }
}
</script>

<style lang="scss" scoped>

$note: 'screen and (max-width: 1280px)';

/*---- Mixins ----*/
@mixin mq($mqString) {
  @media #{$mqString} {
    @content;
  }
}
%ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pointer {
  cursor: pointer;
}

.navBox {
  zoom: 0.8;
  width: 100%;
  min-width: 1200px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  background-color: #fff;
  transition: 0.5s all ease;
  -o-transition: 0.5s all ease;
  -ms-transition: 0.5s all ease;
  -moz-transition: 0.5s all ease;
  -webkit-transition: 0.5s all ease;
  box-shadow: 0 0 10px 3px rgba(60, 60, 60, 0.2);
  -moz-box-shadow: 0 0 10px 3px rgba(60, 60, 60, 0.2);
  -webkit-box-shadow: 0 0 10px 3px rgba(60, 60, 60, 0.2);

  &.on {
    background-color: rgba(0, 0, 0, 1) !important;
  }

  .active-box {
    width: 100%;
    height: 80px;
    background: #000000;

    .active {
      position: relative;
      width: 1170px;
      height: 80px;
      margin: 0 auto;

      .close-btn {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        width: 26px;
        height: 26px;
        background: url("../assets/nav/close-btn.png") no-repeat center center / 100%;
      }
    }
  }

  .top-nav-box {
    width: 100%;
    background: #F4F6F8;
    border: 1px solid #EDEDED;

    .top-nav-con {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 1170px;
      height: 36px;
      margin: 0 auto;
      font-size: 14px;
      color: #333333;

      @include mq($note) {
        width: 940px;
        height: 28px;
        font-size: 11px;
      }
    }

    .left-con {
      display: flex;

      .logo-con {
        margin-right: 30px;
      }

      .gzh-box, .xcx-box {
        position: relative;
        display: flex;
        align-items: center;
        margin-right: 30px;

        .icon-xiangxia2 {
          display: inline-block;
          transform: rotate(0);
          transition: all .4s;
        }

        &:hover {
          .icon-xiangxia2 {
            transform: rotate(180deg);
          }
          img {
            display: block;
          }
        }

        img {
          display: none;
          z-index: 9;
          position: absolute;
          left: -16px;
          top: 27px;
          width: 120px;
          transition: all 1s;
        }
      }
    }

    .right-con {
      display: flex;
      height: 100%;

      .kefu-qq:hover {
        color: #3dc6ef;
      }

      .kefu-qq, .phone-con {
        display: flex;
        align-items: center;
        margin-right: 30px;

        img {
          height: 18px;
          margin-right: 3px;

          @include mq($note) {
            height: 14px;
          }
        }
      }

      .meCore {
        position: relative;
        width: 115px;
        display: flex;
        align-items: center;
        justify-content: center;

        .login-user-name{
          cursor: pointer;
          margin: 0 10px;
          display: inline-block;
          width: 115px;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &:hover{
            color: #3dc6ef;
          }
        }

        .meCore-completion-tag{
          position: absolute;
          top: 22px;
          right: 18px;
          width: 60px;
          height: 20px;
          line-height: 20px;
          font-size: 12px;
          text-align: center;
          border-radius: 10px;
          background-color: #d74324;
          color: #fff;
          cursor: pointer;
          &:hover{
            background-color: lighten(#d74324, .1);
          }
        }
      }
    }
  }


  .navCont {
    position: relative;
    height: 70px;
    margin: 0 auto;
    text-align: center;
    line-height: 70px;
    font-size: 18px;
    width: 1170px;
    box-sizing: border-box;
    padding: 0;
    padding-left: 8px;

    @include mq($note) {
      width: 940px;
      height: 56px;
      line-height: 56px;
      padding-left: 4px;
      font-size: 12px;
    }

    .leftLogo {
      width: 100px;
      height: 100%;
      background-position: center;
      background-size: 100% auto;
      background-image: url("../assets/nav/newLogoSquare.png");
      background-repeat: no-repeat;
      text-indent: -9999em;
      margin: 0;
      float: left;
      cursor: pointer;

      @include mq($note) {
        width: 88px;
      }

      > a {
        display: block;
      }
    }

    .rightCont {
      width: 920px;
      height: 100%;
      display: flex;
      justify-content: space-between;
      line-height: 70px;
      font-size: 18px;
      color: #121212;
      font-family: '微软雅黑';
      font-weight: normal;

      @include mq($note) {
        width: 704px;
        line-height: 56px;
        font-size: 13px;
      }

      .navSj {
        width: 19px;
        height: 12px;
        background-image: url(/static/pc/img/newStyle/navSj.png);
        background-repeat: no-repeat;
        background-size: 100%;
        position: absolute;
        top: 68px;
        left: 50%;
        margin-left: -10px;
        display: none;
      }

      .xiaList {
        display: none;
        position: absolute;
        top: 70px;
        z-index: 100;
        color: #121212;
        font-size: 18px;
        padding: 10px 0;
        border-top: 1px solid #eee;
        box-shadow: 0 4px 14px 0 rgba(51, 51, 51, 0.2);
        -moz-box-shadow: 0 4px 14px 0 rgba(51, 51, 51, 0.2);
        -webkit-box-shadow: 0 4px 14px 0 rgba(51, 51, 51, 0.2);

        @include mq($note) {
          top: 56px;
          padding: 8px 0;
          font-size: 13px;
        }
      }

      .navErItem {
        height: 40px;
        line-height: 40px;
        position: relative;

        @include mq($note) {
          height: 32px;
          line-height: 32px;
        }
      }
      .nav-align-left{
        text-align: left;
        padding-left: 32px;

        @include mq($note) {
          padding-left: 30px;
        }
        .title-text-cus{
          display: inline-block;
          line-height: 1;
          font-weight: bold;
          color: #121212;
          padding-left: 8px;
          margin-top: 8px;
          border-left: 3px solid #121212;
          cursor: auto;
          &:hover{
            color: #3dc6ef;
            border-color: #3dc6ef;
          }
        }
      }
    }

    .navListLibrary {
      width: 840px;
      height: 100%;
      margin-left: 25px;
      display: flex;
      justify-content: space-between;

      li {
        position: relative;
        flex: auto;

        &:hover > a {
          color: #0076d5;
        }

        a {
          color: #121212;
          display: inline-block;
          height: 100%;
          width: 100%;
          font-size: 16px;

          &.active {
            color: #0076d5;
          }
        }
      }
    }

    .library-info-name {
      font-size: 16px;
    }
  }

  .searchBox {
    position: absolute;
    top: 16px;
    right: 0;

    @include mq($note) {
      top: 11px;
    }

    .searchCon {
      position: relative;
      height: 40px;
      line-height: 40px;

      @include mq($note) {
        height: 32px;
        line-height: 32px;
      }

      .searchImg {
        z-index: 1;
        position: absolute;
        left: 10px;
        top: 12px;
        width: 16px;

        @include mq($note) {
          top: 10px;
          width: 12px;
        }
      }

      .form-control {
        box-sizing: border-box;
        width: 220px;
        height: 40px;
        line-height: 27px;
        text-align: left;
        padding: 6px 60px 6px 34px;
        font-size: 16px;
        color: #666;
        transition: all 0.5s;
        border: 1px solid #e1e1e1;
        border-radius: 2px 0 0 2px;
        background-color: #ffffff;

        @include mq($note) {
          width: 190px;
          height: 32px;
          line-height: 20px;
          font-size: 12px;
        }

        &:focus {
          width: 400px;
        }
      }

      .searchBtn {
        position: absolute;
        right: 0;
        top: 1px;
        width: 57px;
        height: 40px;
        background: #0076CE;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 40px;

        @include mq($note) {
          top: 0;
          width: 46px;
          height: 32px;
          line-height: 32px;
          font-size: 12px;
        }
      }
    }

    .hot-search-content{
      display: none;
      position: absolute;
      background-color: #fff;
      box-shadow: 0 0 4px 2px rgba(0,0,0,0.1);
      left: 0;
      right: 0;
      top: 43px;
      z-index: 9999;
      border-radius: 2px;
      text-align: left;
      margin-top: 0;
      h4{
        margin: 15px;
        margin-bottom: 5px;
        color: #999;
        font-size: 12px;
        line-height: 30px;
      }
      ul {
        padding:0 0 10px;
        li{
          margin: 0 15px;
          padding: 0 15px;
          height: 30px;
          line-height: 30px;
          list-style: none;
          color: #666;
          font-size: 12px;
          cursor: pointer;
          a{
            color: #666;
            display: block;
          }
          &:hover{
            box-shadow: 0 0 4px 2px rgba(0,0,0,0.1);
          }
        }
      }
    }
  }

  .productBtn .navErItem {
    text-align: left;
    padding-left: 40px;
  }

  .align-left {
    text-align: left;
    padding-left: 10px;
  }

  .white-space {
    white-space: nowrap;
  }

  .cus-width {
    width: 190px !important;
    margin-left: -80px !important;
    @include mq($note) {
      width: 144px !important;
      margin-left: -72px !important;
    }
  }

  .navCont .rightCont {
    .navItemList .productBtn .xiaList {
      width: 235px;
      left: 67%;

      @include mq($note) {
        width: 144px;
        left: -72px;
      }
    }

    .navErItem {
      &:hover {
        a {
          color: #3dc6ef;
        }

        color: #3dc6ef;
        cursor: pointer;
      }

      &.nohover {
        &:hover a {
          color: #121212;
        }

        span:hover {
          cursor: default;
        }
      }
    }

    .navItemList .xiaList {
      width: 180px;
      left: 50%;
      margin-left: -86px;
      background: rgba(255, 255, 255, 0.96);

      @include mq($note) {
        width: 144px;
        margin-left: -72px;
      }

      &.xiaListWidth {
        width: 210px;
        margin-left: -100px;

        @include mq($note) {
          width: 180px;
          margin-left: -84px;
        }
      }
    }
  }

  .navItemList, .navIcoList {
    width: 650px;
    height: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;

    @include mq($note) {
      width: 500px;
    }
  }

  .navItemList li a, .navIcoList li a {
    color: #121212;
    display: inline-block;
    height: 100%;
    width: 100%;
  }

  .navItemList li, .navIcoList li {
    position: relative;
    -webkit-box-flex: 1;
    -webkit-flex: auto;
    -ms-flex: auto;
    flex: auto;
  }

  .navErBtn {
    position: relative;

    .nav-tag {
      position: absolute;
      right: -12px;
      top: 10px;
      width: 40px;
      height: 20px;
      line-height: 20px;
      border-radius: 10px;
      border-bottom-left-radius: 0;
      background-color: #f00f00;
      color: #fff;
      font-size: 12px;
      text-align: center;
    }

    .more-icon {
      position: absolute;
      width: 20px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      right: 0;
      top: 25px;
      color: #767676;
      font-size: 12px;
      transform: rotate(90deg);
      transition: all .5s;

      @include mq($note) {
        width: 14px;
        height: 14px;
        line-height: 14px;
        top: 22px;
      }
    }

    &:hover {
      .more-icon {
        transform: rotate(-90deg);
      }
    }
  }

  .navItemList {
    .navErList {
    }

    li {
      > a.noHref {
        cursor: default;
      }

      &:hover > a {
        color: #3dc6ef;
      }
    }
  }

  .hot-tag, .new-tag, .aipc-tag {
    display: inline-block;
    position: relative;
    top: -5px;
    left: 3px;
    //animation: hotAni .3s infinite;
    &:after {
      content: 'Hot';
      font-size: 13px;
      color: #ff0000;
      font-weight: bold;
    }
  }

  .new-tag {
    &:after {
      content: 'New';
    }
  }

  .aipc-tag {
    &:after{
      content: 'AI PC';
      color: #0085fa;
    }
  }

  .navIcoList {
    width: 130px;

    li {
      background-position: center;
      background-repeat: no-repeat;
    }
  }

  .pcSoBox {
    width: 640px;
    height: 40px;
    position: absolute;
    top: 21px;
    left: -600px;
    background: #f9f9f9;
    display: none;
    transition: 1s all ease;
    -webkit-transition: 1s all ease;
    -moz-transition: 1s all ease;
    -ms-transition: 1s all ease;
    -o-transition: 1s all ease;

    &.on {
      animation: pcSoBoxAni .5s;
      -moz-animation: pcSoBoxAni .5s;
      -webkit-animation: pcSoBoxAni .5s;
      -o-animation: pcSoBoxAni .5s;
    }

    .hot-search-content {
      display: none;
      position: absolute;
      background-color: #fff;
      box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.1);
      left: 0;
      right: 0;
      z-index: 9999;
      top: 100%;
      margin-top: 5px;
      border-radius: 2px;
      text-align: left;

      h4 {
        margin: 15px;
        margin-bottom: 5px;
        color: #999;
        font-size: 12px;
        line-height: 30px;
      }

      ul {
        padding: 0 0 10px;

        li {
          margin: 0 15px;
          padding: 0 15px;
          height: 30px;
          line-height: 30px;
          list-style: none;
          color: #666;
          font-size: 12px;
          cursor: pointer;

          a {
            color: #666;
            display: block;
          }

          &:hover {
            box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.1);
          }
        }
      }
    }
  }

  @keyframes pcSoBoxAni {
    from {
      transform: translateX(600px);
    }

    to {
      transform: translateX(0);
    }
  }

  @-moz-keyframes pcSoBoxAni {
    from {
      -moz-transform: translateX(600px);
    }

    to {
      -moz-transform: translateX(0);
    }
  }


  @-webkit-keyframes pcSoBoxAni {
    from {
      -webkit-transform: translateX(600px);
    }

    to {
      -webkit-transform: translateX(0);
    }
  }


  @-o-keyframes pcSoBoxAni {
    from {
      -o-transform: translateX(600px);
    }

    to {
      -o-transform: translateX(0);
    }
  }


  #pcSoInp {
    width: 100%;
    height: 100%;
    line-height: 40px;
    display: block;
    font-size: 18px;
    color: #a0a0a0;
    padding: 0 20px;
  }

  .pcSoBokBtn {
    width: 60px;
    height: 100%;
    font-size: 18px;
    color: #fff;
    float: left;
    background-image: url(/static/pc/img/newStyle/chaImg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 30px auto;
  }

  .navIcoList .meList {
    width: 152px;
    left: 50%;
    margin-left: -76px;
    background: rgba(255, 255, 255, 0.96);
    text-align: center;

    .headImg {
      width: 85px;
      height: 85px;
      border-radius: 50%;
      overflow: hidden;
      background: #ccc;
      margin: 30px auto;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(/static/pc/img/newStyle/meIco.png);
      -webkit-background-size: contain;
      background-size: contain;
    }
  }

  .productListBox {
    width: 100%;
    position: absolute;
    top: 80px;
    left: 0;
    display: none;
    background-color: #212121;
    border-bottom: 5px solid #007db8;
    z-index: 9;
  }

  .productListCont {
    width: 1420px;
    margin: 0 auto;

    > .felxItem > a > .title:hover {
      color: #3dc6ef;
    }
  }

  .allNavBox {
    width: 100%;
    position: absolute;
    top: 80px;
    left: 0;
    display: none;
    background: rgba(255, 255, 255, 0.96);
    z-index: 9;
    border-top: 1px solid #eee;
    box-shadow: 0 4px 14px 0 rgba(51, 51, 51, 0.2);
    -moz-box-shadow: 0 4px 14px 0 rgba(51, 51, 51, 0.2);
    -webkit-box-shadow: 0 4px 14px 0 rgba(51, 51, 51, 0.2);
  }

  .bigNavList {
    padding: 30px 0;
    color: #333;

    .title {
      font-size: 14px;
      font-weight: bold;
      line-height: 2em;
      position: relative;
      text-align: left;

      a {
        color: #333;

        &:hover {
          color: #3dc7ee;
        }
      }

      span {
        display: inline-block;
        font-size: 14px;
        color: #999;
        margin-left: 6px;
        position: relative;
        bottom: 1px;
      }
    }
  }

  .allNavCont .itemListUl {
    display: block;
  }

  .bigNavList .itemListUl {
    a, span {
      color: #666;
      transition: 0.4s all ease;
    }

    a:hover {
      color: #3dc7ee;
      border-bottom: 1px solid #aae0f8;
    }

    font-size: 12px;
    line-height: 2em;

    .title-text-cus {
      margin: 6px 0;
      display: block;
      line-height: 1;
      font-weight: bold;
      color: #333 !important;
      padding-left: 8px;
      border-left: 3px solid #333;
      cursor: auto;

      &:hover {
        color: #3dc6ef !important;
        border-color: #3dc6ef;
      }
    }
  }

  .allNavBox .allNavCont {
    width: 1160px;
    margin: 0 auto;
  }

  .soMoInp {
    width: 100%;
    height: 2rem;
    background: #2e2e2e;
    margin: 1rem 0 0;
    display: none;
  }

  #moSoInp {
    width: 85%;
    height: 100%;
    font-size: 0.8rem;
    color: #fff;
    padding: 0 5px;
    display: block;
    box-sizing: border-box;
    -o-box-sizing: border-box;
    -ms-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    float: left;
  }

  .moSoBtn {
    width: 15%;
    height: 100%;
    background-image: url(/static/pc/img/newStyle/soIco.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto 1rem;
    float: left;
  }

  .searchLine {
    border: 1px solid #878787;
    height: 18px;
    display: inline-block;
    margin-top: 30px;
    position: relative;
  }

  .icon-sousuo-1 {
    position: relative;
    top: 2px;
    z-index: 9999;
    font-size: 25px !important;
  }

  .icon-sousuo-1, .pcSoBtn .icon-guanbi1 {
    position: relative;
    top: 2px;
    z-index: 9999;
    cursor: pointer;
    font-size: 25px !important;
  }

  .icon-guanbi1 {
    color: #007db8;
  }

  .icon-liebiao-1 {
    position: relative;
    top: 2px;
    font-size: 38px !important;
  }

  .icon-gerenyonghutouxiang-1 {
    position: relative;
    top: 1px;
    font-size: 25px !important;
  }

  i.ckLine {
    width: 3px;
    height: 12px;
    background-color: #3dc7ee;
    margin: 8px 8px 0 0;
    display: none;
  }

  /*三级导航*/

  .navCont .rightCont .navErItem .cpsolution {
    display: none;
    position: absolute;
    text-align: center;
    left: 180px;
    top: 0;
    width: 150px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 4px 14px 0 rgba(51, 51, 51, 0.2);
    -moz-box-shadow: 0 4px 14px 0 rgba(51, 51, 51, 0.2);
    -webkit-box-shadow: 0 4px 14px 0 rgba(51, 51, 51, 0.2);
    transition: all .2s;

    @include mq($note) {
      left: 144px;
      width: 144px;
    }

    &.cpsolution-server {
      left: 235px;
      width: 260px;
    }

    a {
      &:hover {
        color: #3dc6ef;
      }

      &:last-of-type {
        border-bottom: none;
      }
    }
  }

  .nohover .icon-right {
    position: relative;
    top: 1px;
    color: #999;
    font-size: 14px;
  }

  .toTop .icon-dingbu {
    font-size: 24px;
  }

  .bigNavList .itemListUl a.industryItem {
    font-size: 12px;
  }

  .icon-zhexian {
    position: relative;
    top: 4px;
  }

  .no-login-text {
    text-align: right;

    span {
      transition: all .2s;

      &:hover {
        color: #3dc6ef;
      }
    }
  }


  .no-login-text {
    position: relative;
  }

  .login-info {
    display: none;
    position: absolute;
    top: 36px;
    left: -300px;
    background-image: url("../assets/nav/login-info-bg.png");
    background-size: 100%;
    width: 420px;
    height: 331px;
    opacity: 1;
    transition: opacity .3s;
    color: #fff;
    line-height: 22px;
    font-size: 16px;
    text-align: left;
    -webkit-box-shadow: 0 0 10px 3px rgb(27 129 200 / 20%);
    -moz-box-shadow: 0 0 10px 3px rgba(27, 129, 200, .2);
    box-shadow: 0 0 10px 3px rgb(27 129 200 / 20%);
    border-radius: 13px;
    z-index: 9;

    @include mq($note) {
      top: 28px;
    }

    a {
      display: block;
      color: #fff;
    }

    div {
      box-sizing: border-box;
    }

    .user-info {
      height: 187px;
      padding: 26px 28px;
      position: relative;

      .user-info-box {

        a {
          display: flex;
          height: 80px;

          .user-avatar {
            width: 60px;
            height: 60px;

            img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
              overflow: hidden;
            }
          }

          .user-name-comp {
            margin-top: 5px;
            padding-left: 20px;
            color: #fff;

            .user-name {
              font-size: 20px;
              font-weight: bold;
            }

            .user-comp {
              margin-top: 5px;
              width: 280px;
              font-size: 16px;
              @extend %ellipsis;
            }
          }
        }
      }

      .action-btn {
        position: absolute;
        top: 30px;
        right: 28px;
        font-size: 13px;

        span {
          text-decoration: underline;
          margin-left: 10px;
          cursor: pointer;
          transition: color .3s;

          &:hover {
            color: #ddf1f8;
          }
        }

        a {
          display: inline;
          color: #fff;
          transition: color .3s;

          &:hover {
            color: #ddf1f8;
          }
        }
      }

      .user-data {
        display: flex;
        justify-content: space-between;

        .user-data-item {
          margin-top: 5px;

          a {
            color: #fff;
            text-align: center;
            font-size: 16px;
            transition: color .3s;

            &:hover {
              color: #ddf1f8;
            }

            .user-data-name {
              margin-top: 5px;
            }
          }
        }
      }
    }

    .vip-serve {
      display: flex;
      justify-content: space-between;
      padding: 20px 20px 0;

      .vip-item a {
        width: 80px;
        text-align: center;
        display: flex;
        flex-flow: column;
        align-items: center;

        &:hover {
          .vip-icon {
            background-color: #ddf1f8;
          }
        }

        .vip-icon {
          width: 60px;
          height: 60px;
          background-color: #e3f7fe;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: background-color .3s;

          img {
            width: 35px;
          }
        }

        .vip-name {
          margin-top: 5px;
          color: #404040;
          font-size: 15px;
        }

        .vip-desc {
          font-size: 12px;
          color: #6b6b6b;
          word-break: keep-all;
          transform: scale(.9);
        }
      }
    }

    .loading-box {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(255, 255, 255, .8);
      top: 0;
      border-radius: 13px;

      img {
        width: 25px;
        height: 25px;
      }
    }
  }

  .meCore-is-login {
    &:hover {
      .login-info {
        display: block;
        opacity: 1;
      }
    }
  }
}
</style>

